import { useEffect } from "react";

export default function GlobalImageProtection() {
  useEffect(() => {
    const isProtectedMedia = (el) =>
      el instanceof HTMLImageElement || el instanceof HTMLVideoElement;

    const protectMediaElement = (el) => {
      if (!isProtectedMedia(el)) return;

      el.setAttribute("draggable", "false");
      el.style.userSelect = "none";
      el.style.webkitUserSelect = "none";
      el.style.webkitUserDrag = "none";

      if (el instanceof HTMLVideoElement) {
        el.setAttribute("controlsList", "nodownload noplaybackrate");
        el.setAttribute("disablePictureInPicture", "true");
        el.setAttribute("playsinline", "true");
      }
    };

    const protectAllMedia = () => {
      document.querySelectorAll("img, video").forEach(protectMediaElement);
    };

    const handleContextMenu = (e) => {
      if (isProtectedMedia(e.target)) {
        e.preventDefault();
      }
    };

    const handleDragStart = (e) => {
      if (isProtectedMedia(e.target)) {
        e.preventDefault();
      }
    };

    const handleSelectStart = (e) => {
      if (isProtectedMedia(e.target)) {
        e.preventDefault();
      }
    };

    protectAllMedia();

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("selectstart", handleSelectStart);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (isProtectedMedia(node)) {
            protectMediaElement(node);
          } else if (node instanceof HTMLElement) {
            node.querySelectorAll?.("img, video").forEach(protectMediaElement);
          }
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("selectstart", handleSelectStart);
      observer.disconnect();
    };
  }, []);

  return null;
}